import React, { useContext, useEffect, useState } from 'react';
import { Link, useNavigate, useParams, useLocation } from 'react-router-dom';
import {useCookies} from 'react-cookie';
import axios from 'axios';
import { base_url } from '../url_variables';
import { TostMessageContext } from "../context/TostMessage";
import ReactLoading from 'react-loading';
import { FaCalendarAlt, FaUser, FaSignOutAlt, FaCogs, FaSearch, FaTasks } from "react-icons/fa";
import { IoMdChatboxes } from "react-icons/io";
import { AiOutlineClockCircle, AiOutlineClose } from "react-icons/ai";
import { HiOutlineBookOpen } from "react-icons/hi";
import { MdOutlineDashboard, MdLanguage, MdPayment } from "react-icons/md";
import { UserContext } from '../context/UserContext';
import { MenuContext } from '../context/MenuContext';
import {SiGoogleclassroom} from "react-icons/si";
import { FaUsersBetweenLines } from 'react-icons/fa6';
import { LiaUsersCogSolid } from 'react-icons/lia';
import { ImProfile } from 'react-icons/im';
import { IoCalendarOutline } from 'react-icons/io5';
import LOGO from '../images/CLS-Logo.png';
import { PiUserList, PiUserListBold } from "react-icons/pi";

export function SideMenu() {
    const navigate = useNavigate();
    const params = useParams();
    const location = useLocation();
    const {logOutFunction} = useContext(UserContext);
    const { menuOpen, setMenuOpen } = useContext(MenuContext)
    const cookies = useCookies();
    const {userProfile} = useContext(UserContext);
    const {setTostMessage} = useContext(TostMessageContext)

    useEffect(() => {
        console.log(menuOpen)
    }, [])
 
  return (
        <aside className={`transition-transform duration-500 fixed lg:relative top-0 bottom-0 z-[50] lg:z-[0] w-64 bg-[#FAFAFA] p-6 px-8 ${menuOpen ? 'flex' : 'hidden lg:flex'} flex-col justify-between`}>
            <div>
            <div className='flex justify-between lg:justify-start items-center w-full mt-[10px] mb-[30px]'>
                <img src={LOGO} className="h-[50px] lg:h-[70px] rounded-full mr-2" alt="logo" />
                <h1 className="font-bold text-[14px] lg:text-[17px]">CHILDREN'S LANGUAGE SCHOOL</h1>
                <div
                    onClick={() => setMenuOpen(false)}
                    className="block lg:hidden btn btn-ghost btn-circle mb-4 self-end"
                >
                    <AiOutlineClose className="h-7 w-7 text-dark" />
                </div>
            </div>
            <ul className="space-y-5 text-[17px] text-gray-600">
                <li onClick={() => {navigate('/home');setMenuOpen(false); }} className={`flex items-center cursor-pointer ${location.pathname == "/home" && 'bg-yellow rounded-md px-3 py-2 font-medium text-dark'}`}>
                <MdOutlineDashboard className="mr-2" /> Home
                </li>
                <li onClick={() => {navigate('/my-classes');setMenuOpen(false); }} className={`flex items-center cursor-pointer ${(location.pathname == "/my-classes" || location.pathname == "/enroll" || location.pathname == "/enroll/confirm-enrollment" || location.pathname == "/enroll/confirm-private-enrollment") && 'bg-yellow rounded-md px-3 py-2 font-medium text-dark'}`}>
                <FaUsersBetweenLines className="mr-2" /> My Classes
                </li>
                <li onClick={() => {navigate('/my-students');setMenuOpen(false); }} className={`flex items-center cursor-pointer ${(location.pathname == "/my-students") && 'bg-yellow rounded-md px-3 py-2 font-medium text-dark'}`}>
                <PiUserListBold className="mr-2" /> My Students
                </li>
                <li onClick={() => {navigate('/timetable');setMenuOpen(false); }} className={`flex items-center cursor-pointer ${location.pathname == "/timetable" && 'bg-yellow rounded-md px-3 py-2 font-medium text-dark'}`}>
                <IoCalendarOutline className="mr-2" /> Timetable
                </li>
                {/* <li onClick={() => {navigate('/tasks');setMenuOpen(false); }} className={`flex items-center cursor-pointer ${location.pathname == "/tasks" && 'bg-yellow rounded-md px-3 py-2 font-medium text-dark'}`}>
                <FaTasks className="mr-2" /> My Tasks
                </li> */}
                <li onClick={() => {navigate('/assigned-classes');setMenuOpen(false); }} className={`flex items-center cursor-pointer ${(location.pathname == "/assigned-classes/tasks/create-task" || location.pathname == "/assigned-classes/tasks" || location.pathname == "/assigned-classes") && 'bg-yellow rounded-md px-3 py-2 font-medium text-dark'}`}>
                <LiaUsersCogSolid className="mr-2" /> Assigned Classes
                </li>
                {/* <li onClick={() => {if(userProfile?.account_type == "main") { navigate('/subscriptions');setMenuOpen(false); } else {setTostMessage({ messageType: 'warning', message: 'Action not permitted for children accounts.' })}  }} className={`flex items-center ${userProfile?.account_type == 'main' ? 'cursor-pointer' : 'cursor-not-allowed'}  ${(location.pathname == "/subscriptions") && 'bg-yellow rounded-md px-3 py-2 font-medium text-dark'}`}>
                <MdPayment className="mr-2" /> Subscriptions
                </li> */}

                <li onClick={() => {navigate('/earnings');setMenuOpen(false); }} className={`flex items-center cursor-pointer ${(location.pathname == "/earnings" || location.pathname == "/earnings/history" || location.pathname == "/earnings/payouts") && 'bg-yellow rounded-md px-3 py-2 font-medium text-dark'}`}>
                <MdPayment className="mr-2" /> Earnings
                </li>
                {/* <li className={`flex items-center cursor-pointer ${location.pathname == "/chatbot" && 'bg-yellow rounded-md px-3 py-2 font-medium text-dark'}`}>
                <IoMdChatboxes className="mr-2" /> AI Assistant
                </li>
                <li className={`flex items-center cursor-pointer ${location.pathname == "/calendar" && 'bg-yellow rounded-md px-3 py-2 font-medium text-dark'}`}>
                <FaCalendarAlt className="mr-2" /> Calendar
                </li> */}
                <li onClick={() => {navigate('/my-profile');setMenuOpen(false); }} className={`flex items-center cursor-pointer ${location.pathname == "/my-profile" && 'bg-yellow rounded-md px-3 py-2 font-medium text-dark'}`}>
                <ImProfile className="mr-2" /> Profile
                </li>
            </ul>
            </div>

            <div className="space-y-4 text-sm text-gray-600">
            {/* <div className="flex items-center">
                <FaCogs className="mr-2" /> Settings
            </div> */}
            <div onClick={() => {logOutFunction();setMenuOpen(false); }} className="flex cursor-pointer items-center text-red-500 font-medium">
                <FaSignOutAlt className="mr-2" /> Log Out
            </div>
            </div>
        </aside>
    )
}
